export const track = (event, data = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data, ts: Date.now() });
  if (typeof window.gtag === "function") {
    window.gtag("event", event, data);
  }
};

export const trackPageView = (path) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path });
  }
};
